import { render, staticRenderFns } from "./q-matrix.vue?vue&type=template&id=6e608dce&scoped=true&"
import script from "./q-matrix.vue?vue&type=script&lang=js&"
export * from "./q-matrix.vue?vue&type=script&lang=js&"
import style0 from "./q-matrix.vue?vue&type=style&index=0&id=6e608dce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e608dce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhangenlong/vhall/saas-sdk-questionnaire/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e608dce')) {
      api.createRecord('6e608dce', component.options)
    } else {
      api.reload('6e608dce', component.options)
    }
    module.hot.accept("./q-matrix.vue?vue&type=template&id=6e608dce&scoped=true&", function () {
      api.rerender('6e608dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questionnaire/q-matrix.vue"
export default component.exports